// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__YwS7V","backgroundNavOpen":"styles_backgroundNavOpen__EGoLB"};